module.exports = __webpack_public_path__ + "img/book-logo.04d94072.png";